import { render } from "./StatusUpdateModal.vue?vue&type=template&id=631620fc&scoped=true&ts=true&lang=pug"
import script from "./StatusUpdateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusUpdateModal.vue?vue&type=script&lang=ts&setup=true"

import "./StatusUpdateModal.vue?vue&type=style&index=0&id=631620fc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631620fc"]])

export default __exports__